import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IvyCarouselModule } from 'angular-responsive-carousel';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { CookieService } from 'ngx-cookie-service';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { OrderModule } from 'ngx-order-pipe';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CompaniaModule } from './@pages/compania/compania.module';
import { PedidosModule } from './@pages/pedidos/pedidos.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutModule } from './layout/layout.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    PedidosModule,
    LayoutModule,
    CompaniaModule,
    HttpClientModule,
    NgxSpinnerModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    OrderModule,
    Ng2SearchPipeModule,
    FilterPipeModule,
    NgCircleProgressModule.forRoot({
      radius: 100,
      outerStrokeWidth: 16,
      innerStrokeWidth: 8,
      outerStrokeColor: "#78C000",
      innerStrokeColor: "#C7E596",
      animationDuration: 300,
    }),
    MatDatepickerModule,
    IvyCarouselModule,
    // ServiceWorkerModule.register('combined-sw.js', { enabled: environment.production }),
    // AngularFireModule.initializeApp(environment.firebase),
    // AngularFireMessagingModule
  ],
  providers: [/*{ provide: LocationStrategy, useClass: HashLocationStrategy }*/ CookieService],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {

  }
}
